<template>
    <app-layout>
        <Head>
            <title>Adressen</title>
        </Head>

        <template v-slot:overline>
            <translate>Persönliche Daten</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <div class="addresses">
            <div class="row">
                <div class="col">
                    <card>
                        <card-header>
                            <card-overline><translate>Adressen</translate></card-overline>
                            <card-title><translate>Adressenverwaltung</translate></card-title>
                        </card-header>
                        <card-content>
                            <p>
                                <translate>Tragen Sie hier Ihre eigenen Adressen (Liefer-, sowie Rechnungsadressen) ein.<br>
                                    Sie können <strong>bis zu 6 Adressen</strong> gleichzeitig pflegen und in Ihren Aufträgen zur Verwendung aufrufen.</translate>
                            </p>
                        </card-content>
                        <card-content>
                            <div class="row addresses--grid">
                                <div class="col col-4" v-for="address in clientAddresses" :key="address.index">
                                    <card class="card--outline card--dense card--address">
                                        <card-header>
                                            <card-title>
                                                {{ address.company }}
                                                <badge v-if="address.default_address"><translate>Standard</translate></badge>
                                            </card-title>
                                        </card-header>
                                        <card-content>
                                            <table class="table table--th-middle">
                                                <tr>
                                                    <th><translate>Ansprechpartner:</translate></th>
                                                    <td>{{ address.name }}</td>
                                                </tr>
                                                <tr>
                                                    <th><translate>Abteilung:</translate></th>
                                                    <td>{{ address.street_additional }}</td>
                                                </tr>
                                                <tr>
                                                    <th><translate>Straße / Nr.:</translate></th>
                                                    <td>{{ address.street }} {{ address.street_no }}</td>
                                                </tr>
                                                <tr>
                                                    <th><translate>PLZ / Ort:</translate></th>
                                                    <td>{{ address.zip }} {{ address.city }}</td>
                                                </tr>
                                                <tr>
                                                    <th><translate>Land:</translate></th>
                                                    <td> {{ address.client_country.country_name }}</td>
                                                </tr>
                                                <tr>
                                                    <th><translate>Festnetz:</translate></th>
                                                    <td>{{ address.phone }}</td>
                                                </tr>
                                                <tr>
                                                    <th><translate>Mobil:</translate></th>
                                                    <td>{{ address.mobile }}</td>
                                                </tr>
                                                <tr>
                                                    <th><translate>Fax:</translate></th>
                                                    <td>{{ address.fax }}</td>
                                                </tr>
                                            </table>
                                        </card-content>
                                        <card-content>
                                            <form-actions>
                                                <form-link :route="this.$$route('address.delete', {'clientAddress': address.id})" icon="trash-delete-bin-2"><translate>Löschen</translate></form-link>
                                                <form-button @click="editClientAddress = address; showAddressModal = true" icon="document-edit" color="secondary"><translate>Bearbeiten</translate></form-button>
                                            </form-actions>
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                        </card-content>
                    </card>
                </div>
            </div>
            <div class="row row--sticky" v-sticky v-if="newAddressButton">
                <div class="col">
                    <form-actions>
                        <form-button @click="showAddressModal = true" color="secondary" icon="file-blank-add-plus" class="btn--block"><translate>neue Adresse hinzufügen</translate></form-button>
                    </form-actions>
                </div>
            </div>
        </div>

        <address-modal v-if="showAddressModal" @closeDialog="showAddressModal = false; editClientAddress = null;" :client-countries="clientCountries" :client-address="editClientAddress" />

    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import AddressModal from '@partfactory/Pages/Client/Account/AddressModal';
import FormButton from '@partfactory/Shared/Form/FormButton';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import Badge from '@partfactory/Shared/Elements/Badge';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormLink from '@partfactory/Shared/Form/FormLink';
export default {
    name: 'Addresses',
    components: {
        FormLink,
        FormActions,
        Badge,
        CardTitle, FormButton, AddressModal, CardHeader, CardContent, CardOverline, Card, AppLayout},
    props: {
        clientAddresses: Object,
        clientCountries: Object,
    },
    data() {
        return {
            showAddressModal:false,
            editClientAddress:null,
        };
    },
    computed: {
        newAddressButton() {
            return this.clientAddresses.length < 6;
        }
    }
};
</script>
